import React, { useContext } from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useNavData from '../../cmsHooks/useNavData'
import { OutboundLink } from 'gatsby-plugin-gtag'
import { PaletteContext } from 'styles/PaletteProvider'

import darkModeTalus from 'assets/darkModeTalus.png'
import lightModeTalus from 'assets/lightModeTalus.png'

const FooterContainer = styled.footer`
  height: 90px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.backgroundAlternate};
  border-top: 1px solid ${({ theme }) => theme.neutral1};
  // help footer stay at bottom of page;
  margin-top: auto;
`

const Logo = styled.img`
  height: 45px;
  width: 100%;
`

const Footer = () => {
  const data = useNavData()
  const palette = useContext(PaletteContext)

  return (
    <FooterContainer>
      {/* TODO: add logo of client company here?? */}
      {/* Built by Talus Analytics logo, either dark or light mode */}
      <OutboundLink href={'https://talusanalytics.com/'} target="_blank">
        {palette && (
          <Logo
            src={palette === 'dark' ? darkModeTalus : lightModeTalus}
            alt="Built by Talus Analytics"
          />
        )}
      </OutboundLink>
    </FooterContainer>
  )
}

export default Footer
